import { createContext, useContext } from 'react'

export const SeekTimeContext = createContext({
  seekTime: 0,
  totalTime: 0,
  trickPlayStream: null,
})

export const useSeekTime = () => useContext(SeekTimeContext)
